import { Dayjs } from "dayjs";
import { UserPayload } from "../models/SiteModel";
import { apiFetch } from "./fetchService";

const URLAPI = process.env.REACT_APP_BASE_URL;

export async function fetchGetLocales(user: UserPayload) {
    const token = user.token; // await GetToken(msalcon);
    const response = apiFetch(token, `${URLAPI}/Reportes/GetLocales`, 
        {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
        }});

    const data = await response;
    return data;
}

export async function fetchGetCajas(user: UserPayload, idLocal:string, fecha_desde: Dayjs, fecha_hasta: Dayjs) {
    const token = user.token; // await GetToken(msalcon);
    const dataToPost = {
        idLocal: idLocal,
        fechaDesde: fecha_desde.toJSON(),
        fechaHasta: fecha_hasta.toJSON()
    };
    const response = await fetch(
        `${URLAPI}/Reportes/GetCajas`,
        {
            method: "POST", headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(dataToPost)
        }
    );

    const data = await response.json();
    return data;
}

export async function fetchGetMovimientos(user: UserPayload, idLocal:string, idCaja: string, pv:string, cajaAbierta: boolean) {
    const token = user.token; // await GetToken(msalcon);
    const dataToPost = {
        idLocal: idLocal,
        idCaja: idCaja,
        pv: pv,
        cajaAbierta: cajaAbierta
    };
    const response = await fetch(
        `${URLAPI}/Reportes/GetMovimientos`,
        {
            method: "POST", headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(dataToPost)
        }
    );

    const data = await response.json();
    return data;
}

export async function fetchGetReporteVentas(
    user: UserPayload,
    fecha_desde: Dayjs, fecha_hasta: Dayjs, id_local: number) {

    const token = user.token; // await GetToken(msalcon);
    const dataToPost = {
        fechaDesde: fecha_desde.toJSON(),
        fechaHasta: fecha_hasta.toJSON(),
        idLocal: id_local
    };
    const response = await fetch(
        `${URLAPI}/Reportes/GetReporteVentas`,
        {
            method: "POST", headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(dataToPost)
        }
    );

    const data = await response.json();
    return data;
}

export async function fetchGetReporteEstadosDeCuentasClientes(id_local: string, user: UserPayload) {
    const token = user.token; // await GetToken(msalcon);
    const response = await fetch(
        `${URLAPI}/Cliente/GetEstadosDeCuentasCorrientesLocal/${id_local}`,
        {
            method: "GET", headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }
    );

    const data = await response.json();
    return data;
}

export type ReporteStockPorLocalItem = {
    idProducto: number;
    codigo: string;
    producto: string;
    stock: number;
    descripcion: string;
    presentacion: string;
    precioContado: number;
    precioMayor: number;
    precioMenor: number;
    precioCompra: number;
    idRubro: number;
    rubro: string;
    activo: boolean;
    estado: string;
};

export type ReporteStockPorLocalPage = {
    items: ReporteStockPorLocalItem[];
    total: number;
    page: number;
    pageSize: number;
};

export async function fetchGetReporteStockPorLocal(
    user: UserPayload,
    idLocal: string,
    page: number,
    pageSize: number,
    filters: {
        search?: string;
        idRubro?: number;
        incluirDesactivados?: boolean;
        comparadorStock?: string;
        cantidadStock?: number;
    },
    signal?: AbortSignal
): Promise<ReporteStockPorLocalPage> {
    const params = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
        incluirDesactivados: String(Boolean(filters.incluirDesactivados)),
    });
    if (filters.search?.trim()) params.set("search", filters.search.trim());
    if (filters.idRubro) params.set("idRubro", String(filters.idRubro));
    if (filters.comparadorStock) params.set("comparadorStock", filters.comparadorStock);
    if (filters.cantidadStock !== undefined && Number.isFinite(filters.cantidadStock)) {
        params.set("cantidadStock", String(filters.cantidadStock));
    }

    const response = await fetch(`${URLAPI}/Reportes/GetStockPorLocal/${idLocal}?${params.toString()}`, {
        method: "GET",
        signal,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token
        }
    });

    if (!response.ok) {
        throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return {
        items: data.items ?? data.Items ?? [],
        total: data.total ?? data.Total ?? 0,
        page: data.page ?? data.Page ?? page,
        pageSize: data.pageSize ?? data.PageSize ?? pageSize,
    };
}

export async function fetchExportReporteStockPorLocalTodo(
    user: UserPayload,
    idLocal: string,
    incluirDesactivados: boolean
): Promise<Blob> {
    const params = new URLSearchParams({
        incluirDesactivados: String(incluirDesactivados),
    });

    const response = await fetch(`${URLAPI}/Reportes/ExportStockPorLocalTodo/${idLocal}?${params.toString()}`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + user.token
        }
    });

    if (!response.ok) {
        throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    return response.blob();
}
